import { useCallback, useEffect, useRef, useState } from "react";

/** Copie une chaîne dans le presse-papier et expose un accusé de réception éphémère. */
export function useCopy(resetAfterMs = 1200) {
  const [copied, setCopied] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Sans ce nettoyage, un démontage pendant le délai déclencherait un setState
  // sur un composant disparu.
  useEffect(() => () => void (timer.current && clearTimeout(timer.current)), []);

  const copy = useCallback(
    async (value: string) => {
      try {
        await navigator.clipboard.writeText(value);
        setCopied(value);
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => setCopied(null), resetAfterMs);
      } catch {
        // Presse-papier refusé (contexte non sécurisé, permission) : on n'insiste pas.
      }
    },
    [resetAfterMs],
  );

  return { copy, copied };
}
